import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {MenuItem, TextField, useTheme} from '@mui/material';

import {LanguageContext} from '../../../../contexts/LanguageContext/LanguageContext';
import {useApiRead} from '../../../../hooks/useApiRead';
import {getFieldStyle} from '../../../../layouts/theme/FieldStyles';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';
import {ProfessionalArea} from '../../../../types/ProfessionalArea';

interface Props {
  onChange: (category?: ProfessionalArea) => void;
  value: string;
}
export const ProfessionalAreasSelect = ({onChange, value}: Props) => {
  const theme = useTheme();
  const currentLanguage = useContext(LanguageContext);
  const {t} = useTranslation();

  const {data, isLoading} = useApiRead<ProfessionalArea[]>({path: GetRoutes.professionalAreas});

  if (isLoading || !data) {
    return null;
  }

  return (
    <TextField
      id='area'
      select
      fullWidth
      label={t('applicantOnboarding.qualifications.formLabels.area')}
      onChange={(event) => {
        onChange(data.find((category) => String(category.id) === event.target.value));
      }}
      value={value}
      sx={getFieldStyle(theme)}
    >
      {data.map((option) => {
        return (
          <MenuItem key={option.name[currentLanguage]} value={String(option.id)}>
            {option.name[currentLanguage]}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
